<script lang="ts">
  import { getGroupedCMSComponentsFromHybrisAsync } from '../services/hybris';
  import ImageTag from './ImageTag.svelte';
  import { isMobileWidth } from '../../../common/util';
  export let metaData;
  export function onLoad() {
    const extraShopByCategoryList = metaData?.extraShopByCategoryList.split(' ');
    const extraStaticPromotors = metaData?.staticPromotors.split(' ');

    return getGroupedCMSComponentsFromHybrisAsync([extraShopByCategoryList, extraStaticPromotors]).then(
      ([shopByData, staticPromotorsData]) => {
        staticPromotors = staticPromotorsData;
        shopByCategoryList = shopByData;

        loaded = staticPromotors.length > 0 && shopByCategoryList.length > 0;
        return loaded;
      }
    );
  }

  let loaded = false;
  let staticPromotors = [];
  let shopByCategoryList = [];
  const isResponsive = isMobileWidth();
</script>

<section class="extra-exclusive-wrapper">
  {#if loaded}
    <section class="exclusive-container">
      <section class="flex-left">
        <section class="logo-container">
          {#if !isResponsive}
            <ImageTag imageUrls={[metaData?.logo]} maxHeight={33} />
          {:else}
            <ImageTag imageUrls={[metaData?.appLogo]} maxHeight={48} />
          {/if}
        </section>

        <section class="title-subtitle">
          <p class="title">{metaData?.title}</p>
          <h3>{metaData?.description}</h3>
        </section>

        <section class="static-list">
          {#each staticPromotors as staticPromotor}
            <section class="static-item">
              <div class="static-item-icon">
                <ImageTag imageUrls={[staticPromotor.image]} widths={[45]} heights={[45]} />
              </div>
              <p class="promotor-text">
                {staticPromotor.description}
              </p>
            </section>
          {/each}
        </section>
        {#if !isResponsive && metaData?.buttonTitle}
          <section class="category-tile-button">
            <a
              href={metaData?.buttonRedirectionUrl}
              style="background-color: {metaData?.buttonBackGroundColor}; color: {metaData?.buttonTitleColor}"
              class="category-tile-cta">{metaData?.buttonTitle}</a
            >
          </section>
        {/if}
      </section>
      <section class="flex-right category-tile-list scrollbar-hidden">
        {#each shopByCategoryList as category}
          <a href={category.url} class="category-tile scale-on-hover">
            <div class="tile-content-container">
              <ImageTag imageUrls={[category.imageUrl]} widths={[64, 80]} heights={[64, 80]} />
              <h4>{category.categoryName}</h4>
              {#if category.mainLabel}
                <p>{category.mainLabel}</p>
              {/if}
            </div>
          </a>
        {/each}
      </section>
      {#if isResponsive && metaData?.buttonTitle}
        <section class="category-tile-button">
          <a
            href={metaData?.buttonRedirectionUrl}
            style="background-color: {metaData?.buttonBackGroundColor}; color: {metaData?.buttonTitleColor}"
            class="category-tile-cta">{metaData?.buttonTitle}</a
          >
        </section>
      {/if}
    </section>
  {:else}
    <section class="exclusive-container px48 skeleton-item"></section>
  {/if}
</section>

<style lang="scss">
  @import '../styles/colors.new.scss';
  .extra-exclusive-wrapper {
    padding-inline: 0;
    @include desktop-min-width {
      padding-inline: 48px;
      padding-block: 80px;
    }
    .exclusive-container {
      background: $primary-black url(../../images/class-pro-bg-mobile.png) no-repeat;
      background-position-x: 0;
      background-position-y: top;
      color: $secondary-gray-02;
      padding: 30px 16px;
      display: flex;
      flex-direction: column;
      letter-spacing: 0;

      @include desktop-min-width {
        background: $primary-black url(../../images/class-pro-bg.png) no-repeat;
        background-position-x: 47%;
        background-size: contain;
        border-radius: 20px;
        flex-direction: row;
        padding: 40px 40px 40px 48px;
        background-position-y: center;
        height: 448px;
      }

      .flex-left {
        align-items: center;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        gap: 20px;

        @include desktop-min-width {
          display: block;
          padding: 8px 0;
        }

        .logo-container {
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }
        .title-subtitle {
          text-align: center;
          @include desktop-min-width {
            text-align: left;
          }
        }
      }
      &.skeleton-item {
        height: 448px;
      }

      & > * {
        flex-basis: 50%;
      }

      .title {
        color: $primary-yellow-01;
        margin-block: 0 4px;
        font-size: 20px;
        font-weight: 400;
        line-height: 22px;

        @include desktop-min-width {
          margin-block: 28px 8px;
          font-size: 24px;
          line-height: 18px;
        }
      }
      h3 {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        line-height: 21px;
        padding: 0 31px;

        @include desktop-min-width {
          font-size: 30px;
          line-height: 32px;
          padding: 0;
        }
      }
      .static-list {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 6px;
        margin: 8px 0;

        @include desktop-min-width {
          grid-template-columns: repeat(2, 1fr);
          margin-top: 34px;
          gap: 18px;
        }

        .static-item {
          align-items: center;
          display: flex;
          flex-direction: column;
          gap: 8px;
          @include desktop-min-width {
            flex-direction: row;
            gap: 12px;
          }

          .static-item-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 0 0 45px;
            border-radius: 50%;
            :global {
              img {
                height: 45px;
                width: 45px;
              }
            }
          }
        }
      }
      .category-tile-button {
        margin-top: 26px;
        justify-content: center;
        display: flex;
        @include desktop-min-width {
          margin-top: 39px;
          justify-content: flex-start;
        }
        a.category-tile-cta {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          background-color: $primary-yellow-01;
          border-radius: 100px;
          padding: 10px 16px;
          width: max-content;
          height: 36px;
          text-align: center;
          font-weight: 700;
          font-size: 14px;
          line-height: 16px;
          letter-spacing: 0;
          color: $primary-black;
          @include desktop-min-width {
            padding: 15px 36px;
            height: 48px;
            font-size: 16px;
            line-height: 18px;
          }
        }
      }
      .promotor-text {
        margin: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
        text-align: center;

        @include desktop-min-width {
          font-size: 18px;
          line-height: 20px;
          text-align: left;
        }
      }

      .category-tile-list {
        display: flex;
        justify-content: flex-start;
        flex-basis: 100%;
        flex-wrap: nowrap;
        margin-top: 16px;
        overflow: auto hidden;
        gap: 12px;

        @include desktop-min-width {
          justify-content: flex-end;
          flex-wrap: wrap;
          flex-basis: 50%;
          overflow: auto;
          margin-top: 0;
        }

        .category-tile {
          background: $neutral-light-03;
          aspect-ratio: 1;
          width: 120px;
          height: 130px;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 7px;
          @include desktop-min-width {
            border-radius: 12px;
            padding: 10px 11px;
          }
          .tile-content-container {
            align-items: center;
            background: $primary-white;
            border-radius: 4px;
            display: flex;
            flex-direction: column;
            height: 100%;
            padding: 6px 4px;
            width: 100%;
            @include desktop-min-width {
              border-radius: 7px;
              padding: 8px 4px;
            }
          }

          :global(img) {
            flex-grow: 1;
            max-height: 96px;
            object-position: center !important;

            @include responsive {
              max-height: 64px;
            }
          }

          @include desktop-min-width {
            height: 178px;
            padding: 10px 11px;
            width: 178px;
          }

          h4 {
            display: flex;
            align-items: center;
            text-align: center;
            color: $neutral-dark-01;
            margin: 0;
            font-size: 14px;
            font-weight: 700;
            line-height: 1;
            height: 25px;

            @include desktop-min-width {
              margin: 6px 0;
              font-size: 18px;
              height: 20px;
            }
          }
          p {
            margin-block: 0;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            color: $neutral-dark-03;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-top: 2px;
            @include desktop-min-width {
              font-size: 14px;
              font-weight: 500;
              margin-top: 0;
            }
          }
        }
      }
    }
  }
</style>
